import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';
import './Qna.css';
import * as actions from './Actions';
import { fetchInitialData3 } from "../fetchData";
// import Right from '../right/Right';
import Service from '../service/Service';
import Question from './common/Question';
import UserListOverlay from './common/UserListOverlay';
import AnswerOverlay from './common/AnswerOverlay';
import QuestionOverlay from './common/QuestionOverlay';
import ModerationOverlay from './common/ModerationOverlay';

const service = new Service();

class QnaDetail extends Component {
    constructor(props) {
        super(props);
        let initialData = [];
        let serverSideData = {};
        let articleData = [];
        let similarQueData = [];
        this.totalCount = 0;
        this.similarQueCount = 0;
        let metaTitle = "Questions & Answers: Pregnancy, Baby Care, Parenting Tips & Advice";
        let metaDescription = [];
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            serverSideData = window.__initialData__['initialData'];
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                serverSideData = props.staticContext.initialData['initialData'];
            }
        }
        
        if (serverSideData) {
            if (serverSideData['data1'] && serverSideData['data1']['QuestionData'] && serverSideData['data1']['msg'] == "1") {
                initialData = serverSideData['data1']['QuestionData'];
                this.totalCount = parseInt(serverSideData['data1']['QuestionData'][0]['answer_count']);
            }
            if (serverSideData['data2'] && serverSideData['data2']['result'] && serverSideData['data2']['msg'] == "1") {
                articleData = serverSideData['data2']['result'];
            }
            if (serverSideData['data3'] && serverSideData['data3']['QuestionData'] && serverSideData['data3']['msg'] == "1") {
                similarQueData = serverSideData['data3']['QuestionData'];
                this.similarQueCount = parseInt(serverSideData['data3']['search_cnt']);
            }
        }
        if (initialData && initialData.length > 0) {
            metaTitle = initialData[0].question_title + " – FirstCry Parenting";
            metaDescription = [
                { "name": "description", "content": "Find answers & help on '" + initialData[0].question_title + "' at FirstCry Parenting" }
            ]
        }
        let urlAry = this.props.match.params.title.split('-')
        this.questionId = urlAry.pop();
        if (this.questionId.includes('?')) {
            this.questionId = this.questionId.split('?')[0];
        }
        if (this.questionId.includes('#')) {
            this.questionId = this.questionId.split('#')[0];
        }
        this.questionTitle = urlAry.join(" ") + "?";

        if (global.userAry['childData']['UserChildList']) {
            var childData = global.userAry['childData']['UserChildList'].filter(function (item) {
                return !item.IsExpected;
            });
        }
        // if(childData.length == 1){
        //     var default_child_id = childData[0].ChildId;
        // } else {
        //     if(childData.length <= 0){
        //         var default_child_id = "all";
        //     } else {
        //         var default_child_id = 0;
        //     }
        // }
        if(childData){
            var default_child_id = childData[0] && childData[0].ChildId ? childData[0].ChildId: '';
        } else {
            if(!childData){
                var default_child_id = "all";
            } else {
                var default_child_id = 0;
            }
        }
       
        this.state = {
            initialData: initialData,
            articleData: articleData,
            similarQueData: similarQueData,
            metaTitle: metaTitle,
            metaDescription: metaDescription,
            childIdQuePost: default_child_id
        };
        this.qnaPageNo = 1;
        if (this.props.match.params.page && this.props.match.params.page > 0) {
            this.qnaPageNo = parseInt(this.props.match.params.page);
        }
        this.urlHash = this.props.location.hash;
        this.schemaObj = this.setSchemaObj();
    }

    static initialAction(reqUrl, ftk, authData, uId, childData) {
        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        let size = 100;
        if (reqUrl.includes('/page/')) {
            size = parseInt(reqUrl.split('/').pop()) * 10;
        }
        var qUrl = reqUrl.split('/')[3];
        var id = "";
        var question = "";
        if (qUrl.includes('?')) {
            let mainUrl = qUrl.split('?')[0].split('-');
            id = mainUrl.pop();
            question = mainUrl.join(" ") + "?";
        } else {
            let mainUrl = qUrl.split('-');
            id = mainUrl.pop();
            question = mainUrl.join(" ") + "?";
        }
        if (id.includes('#')) {
            id = id.split('#')[0];
        }
        let obj1 = {
            url: global.api_url + "getMyQNADetailsDes",
            body: JSON.stringify({
                "pagesize": size,
                "pageno": 1,
                "question_id": id
            })
        };
        let obj2 = {
            url: global.api_url + "blogs/getsimilararticle",
            body: JSON.stringify({
                "pagesize": 10,
                "pageno": 1,
                "searchtext": question
            })
        };
        let obj3 = {
            url: global.api_url + "getSearchData",
            body: JSON.stringify({
                "pagesize": 10,
                "pageno": 1,
                "searchKey": question,
                "sort_by": 'ansCnt',
                "sort_value": 'desc',
                "isIntent": true,
                "isDesk": true
            })
        };
        return fetchInitialData3(obj1, obj2, obj3, JSON.stringify(header));
    }

    componentDidMount() {
        // service.disableCutCopyPaste('post_answer_text');
        // service.disableCutCopyPaste('post_question_text');
        // if (this.props.location.search.includes('from=app')) {
        //     document.getElementsByClassName('snackbar')[0].style.bottom = '0';
        // }
        document.addEventListener("click", actions.domClick);
        service.loadImages();
        if (navigator.onLine) {
            let size = 100;
            if (this.qnaPageNo > 1) {
                size = 10 * this.qnaPageNo;
            }
            if (!this.state.initialData || (this.state.initialData && this.state.initialData.length < 1)) {
                service.showLoader();
                this.qnaData(1, size);
            } else {
                localStorage.setItem('qnaDetails_' + this.questionId, JSON.stringify(this.state.initialData));
                localStorage.setItem('qnaDetailsCnt_' + this.questionId, JSON.stringify(this.totalCount));
                actions.loadReadMore();
            }
            if (!this.state.articleData || (this.state.articleData && this.state.articleData.length < 1)) {
                service.showLoader();
                this.qnaArticleData(1, 10);
            } else {
                localStorage.setItem('qnaArticleDetails_' + this.questionId, JSON.stringify(this.state.articleData));
            }
            if (!this.state.similarQueData || (this.state.similarQueData && this.state.similarQueData.length < 1)) {
                service.showLoader();
                this.qnaSimilarQueData(1, 10);
            } else {
                localStorage.setItem('qnaSimilarQueDetails_' + this.questionId, JSON.stringify(this.state.similarQueData));
                localStorage.setItem('qnaSimilarQueDetailsCnt_' + this.questionId, JSON.stringify(this.similarQueCount));
                actions.loadReadMore();
            }
        } else {
            if (localStorage.getItem('qnaDetails_' + this.questionId)) {
                this.setState({ initialData: JSON.parse(localStorage.getItem('qnaDetails_' + this.questionId)) }, () => { service.loadImages(); actions.loadReadMore(); });
            }
            if (localStorage.getItem('qnaDetailsCnt_' + this.questionId)) {
                this.totalCount = localStorage.getItem('qnaDetailsCnt_' + this.questionId);
            }
            if (localStorage.getItem('qnaArticleDetails_' + this.questionId)) {
                this.setState({ articleData: JSON.parse(localStorage.getItem('qnaArticleDetails_' + this.questionId)) }, () => { service.loadImages(); });
            }
            if (localStorage.getItem('qnaSimilarQueDetails_' + this.questionId)) {
                this.setState({ similarQueData: JSON.parse(localStorage.getItem('qnaSimilarQueDetails_' + this.questionId)) }, () => { service.loadImages(); actions.loadReadMore(); });
            }
            if (localStorage.getItem('qnaSimilarQueDetailsCnt_' + this.questionId)) {
                this.similarQueCount = localStorage.getItem('qnaSimilarQueDetailsCnt_' + this.questionId);
            }
            service.hideLoader();
        }
        if (this.urlHash && this.urlHash == 'addananswer') {
            if (this.state.initialData && this.state.initialData.length > 0) {
                actions.openAnswerPopup(this.state.initialData[0].question_id, this.state.initialData[0].creater_id);
            }
        }
    }

    componentWillUnmount() {
        document.removeEventListener("click", actions.domClick);
    }

    formatArticleDate(date) {
        let monthAry = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
        let month = monthAry[new Date(date).getMonth()];
        let day = new Date(date).getDate() < 10 ? "0" + new Date(date).getDate() : new Date(date).getDate();
        let year = new Date(date).getFullYear();
        return month + " " + day + ", " + year;
    }

    qnaData(pageno, size) {
        var url = global.api_ci_url + "qna/getMyQNADetailsDes";
        let postData = {
            "pagesize": size,
            "pageno": pageno,
            "question_id": this.questionId
        }
        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == "1") {
                if (this.state.initialData && this.state.initialData.length > 0) {
                    if (size == (pageno * 10)) {
                        this.setState({ initialData: json['QuestionData'] }, () => { service.loadImages(); actions.loadReadMore(); });
                        this.totalCount = parseInt(json['QuestionData'][0]['answer_count']);
                    } else {
                        let ary = this.state.initialData;
                        this.setState({ initialData: ary.concat(json['QuestionData']) }, () => { service.loadImages(); actions.loadReadMore(); });
                    }
                    // if (parseInt(pageno) != 1) {
                    //     this.appendURL();
                    // }
                } else {
                    localStorage.setItem('qnaDetails_' + this.questionId, JSON.stringify(json['QuestionData']));
                    localStorage.setItem('qnaDetailsCnt_' + this.questionId, JSON.stringify(json['QuestionData'][0]['answer_count']));
                    this.totalCount = parseInt(json['QuestionData'][0]['answer_count']);
                    this.setState({ initialData: json['QuestionData'] }, () => { service.loadImages(); actions.loadReadMore(); });
                }
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }

    qnaArticleData(pageno, size) {
        var url = global.api_ci_url + "qna/getsimilararticle";
        let postData = {
            "pagesize": size,
            "pageno": pageno,
            "searchtext": this.questionTitle
        }
        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == "1") {
                if (this.state.articleData && this.state.articleData.length > 0) {
                    if (size == (pageno * 10)) {
                        this.setState({ articleData: json['result'] }, () => { service.loadImages(); });
                    } else {
                        let ary = this.state.articleData;
                        this.setState({ articleData: ary.concat(json['result']) }, () => { service.loadImages(); });
                    }
                } else {
                    localStorage.setItem('qnaArticleDetails_' + this.questionId, JSON.stringify(json['result']));
                    this.setState({ articleData: json['result'] }, () => { service.loadImages(); });
                }
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }

    qnaSimilarQueData(pageno, size) {
        var url = global.api_ci_url + "qna/getSearchData";
        let postData = {
            "pagesize": size,
            "pageno": pageno,
            "searchKey": this.questionTitle,
            "sort_by": 'ansCnt',
            "sort_value": 'desc',
            "isIntent": true,
            "isDesk": true
        }
        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == "1") {
                if (this.state.similarQueData && this.state.similarQueData.length > 0) {
                    if (size == (pageno * 10)) {
                        this.setState({ similarQueData: json['QuestionData'] }, () => { service.loadImages(); actions.loadReadMore(); });
                    } else {
                        let ary = this.state.similarQueData;
                        this.setState({ similarQueData: ary.concat(json['QuestionData']) }, () => { service.loadImages(); actions.loadReadMore(); });
                    }
                } else {
                    localStorage.setItem('qnaSimilarQueDetails_' + this.questionId, JSON.stringify(json['QuestionData']));
                    localStorage.setItem('qnaSimilarQueDetailsCnt_' + this.questionId, JSON.stringify(json['search_cnt']));
                    this.similarQueCount = parseInt(json['search_cnt']);
                    this.setState({ similarQueData: json['QuestionData'] }, () => { service.loadImages(); actions.loadReadMore(); });
                }
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }

    reloadData(queId, ansId) {
        var _this = this;
        setTimeout(() => {
            service.showLoader();
            _this.qnaData(_this.qnaPageNo, (_this.qnaPageNo * 10));
        }, 500)
        service.hideLoader();
    }

    reloadSimilarQueData(queId, actionType, status) {
        var _this = this;
        setTimeout(() => {
            service.showLoader();
            let dataAry = _this.state.similarQueData;
            for (let d = 0; d < dataAry.length; d++) {
                if (dataAry[d]['question_id'] == queId) {
                    if (actionType == "follow") {
                        if (status == 1) {
                            dataAry[d]['que_follow'] = 'true';
                            dataAry[d]['follow_count'] = parseInt(dataAry[d]['follow_count']) + 1;
                        } else {
                            dataAry[d]['que_follow'] = 'false';
                            dataAry[d]['follow_count'] = (parseInt(dataAry[d]['follow_count']) - 1) >= 0 ? parseInt(dataAry[d]['follow_count']) - 1 : 0;
                        }
                    }
                    if (actionType == "abuse") {
                        if (status == 1) {
                            dataAry[d]['que_abuse'] = 'true';
                        } else {
                            dataAry[d]['que_abuse'] = 'false';
                        }
                    }
                }
            }
            _this.setState({ similarQueData: dataAry }, () => { service.loadImages(); actions.loadReadMore(); });
        }, 100);
        service.hideLoader();
    }

    formatSchemaDate(dateString) {
        let date = new Date(dateString);
        let y = date.getFullYear();
        let m = (date.getMonth() + 1) < 10 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1);
        let d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        return y + "-" + m + "-" + d;
    }

    setSchemaObj() {
        let obj = {};
        obj['@context'] = 'https://schema.org';
        obj['@type'] = 'QAPage';
        obj['mainEntity'] = this.getSchemaMainObj();
        return obj;
    }

    getSchemaMainObj() {
        let ansCount = 0;
        let queTitle = '';
        let createdDate = '';
        let maxLikeCnt = 0;
        let acceptedAry = [];
        let suggestedAry = [];
        if (this.state.initialData && this.state.initialData.length > 0) {
            if (this.state.initialData[0]['answer_count']) {
                ansCount = this.state.initialData[0]['answer_count'];
            }
            if (this.state.initialData[0]['question_title']) {
                queTitle = this.state.initialData[0]['question_title'];
            }
            if (this.state.initialData[0]['queCreatedDate']) {
                // createdDate = this.state.initialData[0]['queCreatedDate'];
                createdDate = this.formatSchemaDate(this.state.initialData[0]['queCreatedDate']);
            }
            if (this.state.initialData[0]['answers'] && this.state.initialData[0]['answers'].length > 0) {
                maxLikeCnt = Math.max.apply(Math, this.state.initialData[0]['answers'].map(function (ans) { return ans.ans_like_count; }));
                acceptedAry = this.state.initialData[0]['answers'].filter(function (item) {
                    return maxLikeCnt == item.ans_like_count;
                });
                suggestedAry = this.state.initialData[0]['answers'].filter(function (item) {
                    return maxLikeCnt > item.ans_like_count;
                });
            }
        }
        let mainObj = {};
        mainObj['@type'] = 'Question';
        mainObj['name'] = queTitle;
        mainObj['answerCount'] = ansCount.toString();
        mainObj['dateCreated'] = createdDate;
        // mainObj['dateCreated'] = createdDate.substring(0, 10);
        mainObj['upvoteCount'] = maxLikeCnt.toString();
        mainObj['acceptedAnswer'] = this.getAnswerAry(acceptedAry);
        mainObj['suggestedAnswer'] = this.getAnswerAry(suggestedAry);
        return mainObj;
    }

    getAnswerAry(ary) {
        let aAry = [];
        for (let a = 0; a < ary.length; a++) {
            let index = this.state.initialData[0]['answers'].indexOf(ary[a]);
            let aObj = {};
            aObj['@type'] = 'Answer';
            aObj['text'] = ary[a]['answer_details'];
            aObj['upvoteCount'] = ary[a]['ans_like_count'];
            aObj['url'] = global.currentURL + '#answer_' + (index + 1);
            aObj['dateCreated'] = this.formatSchemaDate(ary[a]['ansCreatedDate']);
            aAry.push(aObj);
        }
        return aAry;
    }

    render() {
        return (
            <main className="qna-main qnadetail-main main-container">
                <Helmet
                    title={this.state.metaTitle}
                    meta={this.state.metaDescription}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><Link to={service.getRedirectUrl("/qna/questions-answers")} className="R11_9e">Questions & Answers</Link></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        {this.state.initialData && this.state.initialData[0] && this.state.initialData[0].question_title &&
                            <span className="long_breadcum">{this.state.initialData[0].question_title}</span>
                        }
                    </div>
                    {/* <h1 className="B24_00">Q&A</h1> */}
                </div>
                <div className="sub-container left">
                    <div className="data-container left">
                        <div className="askAQues loginwindow">
                            <div className="q4 askque-title">Want to share your parenting queries and get answers</div>
                            <div className="q8 askque-text">Get Solutions and advice from other parents and experts</div>
                            <span className="ask-a-que-btn" id="devaskQuestion">
                                <span className="b_1 ask-a-que-btn">
                                    <span className="ask-a-que-btn">Ask a Question</span>
                                </span>
                            </span>
                        </div>
                        {(this.state.initialData && this.state.initialData.length > 0) &&
                            <Question questions={this.state.initialData} isLanding={false} isShowAbuse={true} checkQId={''} eleRef={this} isSimilarQue={false} isShowReadMore={false} />
                        }
                        {(!this.state.initialData || this.state.initialData.length < 1) &&
                            // <div className="question-block">
                                    <div className="alertMsg-overlay"style={{ display: 'block' }}>
                                        <div className="alert-popup">
                                            <span className="alertmsg">Please check internet connection!!</span>
                                        </div>
                                    </div>
                            // </div>
                        }
                        {(this.state.articleData && this.state.articleData.length > 0) &&
                            <div className="similar-block">
                                <div className="pink_title_main">
                                    <span className="M14_white">SUGGESTED ARTICLES</span>
                                </div>
                                <div className="pink_line"></div>
                                {this.state.articleData.map((article, index) =>
                                    <div key={index} className="suggested-articles">
                                        <a href={service.getRedirectUrl(article.article_url.replace("http://", "https://"))}>
                                            <span className="article-img left">
                                                {article.imageUrl &&
                                                    <img src={article.imageUrl.replace("http://", "https://")} />
                                                }
                                            </span>
                                            <div className="article-info left">
                                                <span className="article-title M17_42">{article.articleTitle}</span>
                                                <span className="article-date">{this.formatArticleDate(article.date)}</span>
                                            </div>
                                        </a>
                                    </div>
                                )}
                                {/* <div className="view-more">
                                    <span className="view-more-text M14_42">VIEW MORE ARTICLES</span>
                                </div> */}
                            </div>
                        }
                        {(this.state.similarQueData && this.state.similarQueData.length > 0) &&
                            <div className="similar-block">
                                <div className="pink_title_main">
                                    <span className="M14_white">SIMILAR QUESTIONS</span>
                                </div>
                                <div className="pink_line"></div>
                                <div className="similar_q">
                                    {this.state.similarQueData &&
                                        <Question questions={this.state.similarQueData} isLanding={false} isShowAbuse={true} checkQId={this.questionId} eleRef={this} isSimilarQue={true} isShowReadMore={true} />
                                    }
                                    {/* <div className="view-more">
                                        <span className="view-more-text M14_42">VIEW MORE QUESTIONS</span>
                                    </div> */}
                                </div>
                            </div>
                        }
                        <div className="more-questions">
                            <div className="do-you-know">
                                <span className="M17_42 have-ques">Do you know any solution to this question?</span>
                                <span className="R14_61">Let’s go to the app - To help out fellow parents &amp; to get answers to your questions</span>
                            </div>
                            <div className="askButton" onClick={() => actions.openAnswerPopup(this.state.initialData[0].question_id, this.state.initialData[0].creater_id)} id="devaddAnsewer">
                                <p className="askB_1 ansBt" data-id="add-answer" title="Add An Answer">Add An Answer</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="snackbar" onClick={() => actions.openAnswerPopup(this.state.initialData[0].question_id, this.state.initialData[0].creater_id)} id="devaddAnsewer">
                    <div className="askquebtn">
                        <div data-icon-font="" className="icon"></div>
                        <span className="ask-quen">Add An Answer</span>
                    </div>
                </div>
                {(this.state.initialData && this.state.initialData.length > 0 && this.state.initialData[0]['answer_count'] && this.state.initialData[0]['answer_count'] > 0) ?
                    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(this.schemaObj) }}></script>
                    :
                    null
                }
                <UserListOverlay eleRef={this} />
                <AnswerOverlay eleRef={this} />
                <QuestionOverlay eleRef={this} childData={global.userAry['childData']['UserChildList']} />
                <ModerationOverlay />
                {/* <Right url={this.props.match.url} /> */}
            </main>
        )
    }
}

export default QnaDetail;



// WEBPACK FOOTER //
// src/shared/qna/QnaDetail.js